/**
 * api 接口
 */

const ups = "/unionpay_spa";


const userApi = {
	index_getCityList: ups + "/index/getCityList",
	index_getGoodsList: ups + "/index/getGoodsList",
	index_getGoodsInfo: ups + "/index/getGoodsInfo",
	index_getUserInfo: ups + "/index/getUserInfo",
	index_createOrder: ups + "/order/createOrder",
	index_getPayUrl: ups + "/order/getPayUrl",
	order_orderDetail: ups + "/order/orderDetail",
	order_orderCancel: ups + "/order/orderCancel",
	order_orderClose: ups + "/order/orderClose",
	order_repay: ups + "/order/repay",
	order_changeToken: ups + "/index/changeToken",
	index_getVenueList: ups + "/index/getVenueList",
};
export default {
	userApi
};


// WEBPACK FOOTER //
// ./src/request/api.js